import Marquee from "react-fast-marquee";
import { Sprout } from "lucide-react";

const PHRASES = [
  "No more wasted groceries",
  "Expiry tracking",
  "Gentle alerts",
  "Freshness first",
  "Scan & forget",
  "Eat everything you buy",
];

export default function MarqueeRibbon() {
  return (
    <section className="relative py-12 overflow-hidden" aria-hidden="true">
      <div
        className="rotate-[-1.5deg] scale-[1.03] bg-[#F2C94C] border-y border-[#111111]/15"
        data-testid="freshness-marquee"
      >
        <Marquee speed={35} gradient={false} className="py-4">
          {PHRASES.map((p) => (
            <span
              key={p}
              className="flex items-center font-serif italic text-2xl md:text-4xl text-[#0A130B] whitespace-nowrap"
            >
              {p}
              <Sprout className="h-5 w-5 md:h-7 md:w-7 mx-10 text-[#1F9D55]" />
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
